export default (_v, fn) => {
  fn = () => {}
  const bindHistoryEvent = function(type) {
    const historyEvent = history[type]
    return function() {
        const newEvent = historyEvent.apply(this, arguments) // 执行history函数
       const e = new Event(type) // 声明自定义事件
        e.arguments = arguments
        window.dispatchEvent(e) // 抛出事件
        return newEvent // 返回方法，用于重写history的方法
    }
  }

  history.pushState = bindHistoryEvent('pushState')
  history.replaceState = bindHistoryEvent('replaceState')

  window.addEventListener('popstate', function() {
    let rout = location.pathname.split('/').pop()
    rout = !rout || rout === name ? 'default' : rout
    _v.$track.addStat(_v.productName + '_' + rout)
    _v.currentRouter = rout
    fn()
  })
  window.addEventListener('pushState', function() {
      let rout = location.pathname.split('/').pop()
      rout = !rout || rout === name ? 'default' : rout
      _v.$track.addStat(_v.productName + '_' + rout)
      _v.currentRouter = rout
      fn()
  })
  window.addEventListener('replaceState', function() {
      let rout = location.pathname.split('/').pop()
      rout = !rout || rout === name ? 'default' : rout
      _v.$track.addStat(_v.productName + '_' + rout)
      _v.currentRouter = rout
      fn()
  })
}
